var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3 12a3.6 3.6 0 1 0 0-7.3 3.6 3.6 0 0 0 0 7.3ZM15.4 14.8V35h6.3V25c0-2.7.5-5.2 3.7-5.2 3.3 0 3.3 3 3.3 5.4V35H35V23.9c0-5.5-1.2-9.6-7.5-9.6-3.1 0-5.2 1.6-6 3.2v-2.7h-6.1Zm-10.2 0h6.2V35H5.2V14.8Z"
  })));
};
export default SvgLinkedin;